import styled from "styled-components";
import { ReactComponent as FlixxCoinSVG } from "assets/icons/flixx-coin.svg";
import { Link } from "react-router-dom";

export const Container = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;

  margin-top: 4px;

  color: ${({ theme, $isCreators }) => $isCreators
    ? theme.old.colors.gray[100]
    : theme.old.colors.white
  };
  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
`

export const FlixxCoin = styled(FlixxCoinSVG)`
  height: 14px;
  width: 14px;
`